export default {"src":"/_next/static/image/public/images/ic_star.fad883a3eef2ad05ea5d1aa79480ada6.svg","height":29,"width":30};